export { default as getStorybookComponent } from './getStorybookComponent';
export { default as isStorybook7 } from './isStorybook7';
//# sourceMappingURL=index.js.map